import { AppText } from '../../components/AppText';
import { PrimaryButton } from '../../components/PrimaryButton';
import { SecondaryButton } from '../../components/SecondaryButton';
import { Strings } from '../../strings';
import { SymbolView } from '../../symbols/SymbolView';

export function WelcomeScreen({
  onCreateAccount,
  onSignIn,
}: {
  onCreateAccount: () => void;
  onSignIn: () => void;
}) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minHeight: '100%',
        padding: '0 var(--space-6)',
        gap: 'var(--space-4)',
      }}
    >
      <SymbolView token="star" size={96} color="var(--action-primary)" />

      <AppText as="h1" style="display">
        {Strings.appName}
      </AppText>

      <AppText style="bodyL" color="var(--text-secondary)" sx={{ marginBottom: 'var(--space-8)' }}>
        {Strings.welcomeTagline}
      </AppText>

      <PrimaryButton label={Strings.actionCreateAccount} onClick={onCreateAccount} />

      <SecondaryButton label={Strings.actionHaveAccount} onClick={onSignIn} />
    </div>
  );
}
